import Bookmark from "./Bookmark";
import Note from "./Note";

const BOOKMARKS = "bookmarks";
const NOTES = "notes";

export default class AnnotationStorageProvider {
  /**
   * @param {*} store Key-value store. Uses localStorage by default.
   */
  constructor(store) {
    this.store = store || window.localStorage;
  }

  /**
   * Serializes bookmarks into a JSON string and saves them to storage.
   * @param {number} bookId
   * @param {Bookmark[]} bookmarks
   */
  storeBookmarks(bookId, bookmarks) {
    if (bookmarks.length > 0) {
      this.store.setItem(
        this._storageKey(bookId, BOOKMARKS),
        JSON.stringify(bookmarks),
      );
    } else {
      this.store.removeItem(this._storageKey(bookId, BOOKMARKS));
    }
  }

  /**
   * Retrieves and parses bookmark JSON from storage.
   * @param {number} bookId
   * @returns {Bookmark[]}
   */
  loadBookmarks(bookId) {
    const bookmarks = [];
    const data = JSON.parse(
      this.store.getItem(this._storageKey(bookId, BOOKMARKS)),
    );
    if (data && Array.isArray(data)) {
      for (const json of data) {
        bookmarks.push(Bookmark.fromJson(json));
      }
    }
    return bookmarks;
  }

  /**
   * Serializes notes into a JSON string and saves them to storage.
   * @param {number} bookId
   * @param {Note[]} notes
   */
  storeNotes(bookId, notes) {
    if (notes.length > 0) {
      this.store.setItem(
        this._storageKey(bookId, NOTES),
        JSON.stringify(notes),
      );
    } else {
      this.store.removeItem(this._storageKey(bookId, NOTES));
    }
  }

  /**
   * Retrieves and parses note JSON from storage.
   * @param {number} bookId
   * @returns {Note[]}
   */
  loadNotes(bookId) {
    const notes = [];
    const data = JSON.parse(
      this.store.getItem(this._storageKey(bookId, NOTES)),
    );
    if (data && Array.isArray(data)) {
      for (const json of data) {
        notes.push(Note.fromJson(json));
      }
    }
    return notes;
  }

  _storageKey(bookId, type) {
    return `${type}-${bookId}`;
  }
}
